"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Avatar_1 = __importDefault(require("@material-ui/core/Avatar"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
exports.default = react_1.default.memo(CircularIcon);
const useStyles = makeStyles_1.default((theme) => ({
    icon: {
        color: theme.colors.icon.color,
        backgroundColor: theme.colors.icon.backgroundColor,
        height: props => props.size === "md" ? theme.avatarSize.md : theme.avatarSize.sm,
        width: props => props.size === "md" ? theme.avatarSize.md : theme.avatarSize.sm,
        "& .background": {
            fill: theme.colors.icon.backgroundColor
        }
    }
}));
function CircularIcon(props) {
    const classes = useStyles(props);
    return (react_1.default.createElement(Avatar_1.default, { className: classes.icon }, props.svg));
}
